
import React from "react";
import { Button } from "@/components/ui/button";
import { MessageSquare } from "lucide-react";
import { cn } from "@/lib/utils";

interface FloatingButtonProps {
  onClick: () => void;
  isOpen?: boolean;
  className?: string;
}

const FloatingButton = ({ onClick, isOpen, className }: FloatingButtonProps) => {
  return (
    <Button
      onClick={onClick}
      className={cn(
        "fixed bottom-6 right-6 h-14 w-14 rounded-full shadow-lg z-50 p-0 transition-all duration-300",
        isOpen ? "bg-destructive hover:bg-destructive/90" : "bg-primary hover:bg-primary/90",
        className
      )}
      size="icon"
      aria-label="Open Admin Chat"
    >
      <MessageSquare className="h-6 w-6" />
    </Button>
  );
};

export default FloatingButton;
